import { useState } from 'react';

const TrustSectiion = () => {
  const trustPartners = [
    "United_Parcel_Service-Logo.wine.svg",
    "ARMX.AE_BIG.svg",
    "DHL.DE.svg",
    "DPD_logo_(2015).svg",
    "FDX_BIG.svg",
    "Emirates_(airline)-Logo.wine.svg",
    "turkish-airlines.png",
    "kenya-airways.png",
    "Maersk_Group_Logo.svg",
    "ethiopian-airlines.png"
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className='trust-section-div container'>
        <div className='trust-left-sec'>
          <h3 className='text-uppercase mb-5 Ethnocentric'>Trusted Logistics Partner</h3>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              gap: "30px",
              alignItems: "center",
              justifyContent: "center",
            }}
            className="partners-logo"
          >
            {trustPartners.map((partner, index) => (
              <img
                key={index}
                src={`/assets/images/partners/${partner}`}
                alt={`Partner ${index}`}
                style={{ width: "100px", height: "auto" }}
              />
            ))}
          </div>
        </div>
        <div className='trust-right-sec'>
          <img
            className='certificate'
            src="/assets/images/bluedart-certificate.png"
            alt="bluedart certificate"
            style={{ cursor: 'pointer' }}
            onClick={() => setIsModalOpen(true)}
          />
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div
          onClick={() => setIsModalOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
        >
          <img
            src="/assets/images/bluedart-certificate.png"
            alt="Certificate"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              boxShadow: '0 0 10px #fff',
              borderRadius: '10px'
            }}
          />
        </div>
      )}
    </>
  );
};

export default TrustSectiion;
